import React from "react"
import propTypes from "prop-types"
import { Link } from "react-router-dom"
import { Button } from "reactstrap"

const LogItemList = ({ item }) => {
  const styleCenterTable = { textAlign: "center", verticalAlign: "middle" }

  const statusLabel = {
    pending: { label: "En cola", className: "bg-secondary" },
    processing: { label: "Procesando", className: "bg-warning text-dark" },
    success: { label: "Completado", className: "bg-success" },
    failed: { label: "Fallido", className: "bg-danger" },
  }

  const currentStatus = statusLabel[item?.status] ?? statusLabel.success

  const getFormattedTime = (time) => {
    const newTime = new Date("2023-01-01T" + time + "Z")

    const hours = newTime.getUTCHours()
    const minutes = newTime.getUTCMinutes()
    const seconds = newTime.getUTCSeconds()

    const timeFormatted = hours + " : " + minutes + " : " + seconds
    return timeFormatted
  }

  const formattedDateTime = `${new Date(item.log_date).toLocaleDateString("es-MX", {
    year: "numeric",
    month: "short",
    day: "numeric",
  })} ${getFormattedTime(item.log_time)}`


  return (
    <tr key={item.id}>
      <td style={styleCenterTable}>
        <Link to={{ pathname: `/logs-importation/${item.id}` }}>{item.id}</Link>
      </td>
      <td style={styleCenterTable}>
        {formattedDateTime}
      </td>
      <td style={styleCenterTable}>{item.type_model}</td>
      <td style={styleCenterTable}>
        <span className={`badge ${currentStatus.className}`}>{currentStatus.label}</span>
      </td>
      <td style={styleCenterTable} className="text-center">
        {item?.user?.first_name} {item?.user?.last_name}
      </td>
      <td style={styleCenterTable}>
        <Link
          to={{ pathname: `/logs-importation/${item.id}` }}
          title="Ver detalles"
          aria-label="Ver detalles"
          color="success"
        >
          <Button 
          color="success"
          title="Ver detalles"
          >
            <i className="fa fa-list" />
          </Button>
        </Link>
      </td>
    </tr>
  )
}

LogItemList.propTypes = {
  item: propTypes.object,
}

export default LogItemList
